<div class="d-flex page__box p-3 mt-3 header">
  <mat-icon class="toggle">dashboard</mat-icon> All Apps
</div>
<div class="row">
  <div class="col-12 text-end">
    <button class="mat-button btn1 btn-primary" (click)=onAddButtonClick() ><i class="fa fa-plus" aria-hidden="true"></i>
      Add App</button>
  </div>
</div>

<div class="row">
  <div class="col-1"></div>
  <div class="col-5 text-start">
    <div class="search-container">
      <i class="fa fa-search search-icon"></i>
      <input type="text" [(ngModel)]="searchTerm" (input)="applyFilter()" placeholder="Search..." class="search-input">
    </div>
  </div>
  <div class="col-6 text-end">
    <div class="pagination-container">
      <app-pagination [currentPage]="currentPage" [totalItems]="totalItems" [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions" (pageChange)="onPageChange($event)"
        (onPagesizechange)="Pagesizechange($event)"></app-pagination>
    </div>
  </div>
</div>
<div class="card-container">
 <mat-card class="example-card" *ngFor="let app of filteredItems" [ngClass]="{'changed-card': appchanges[app?.cl_cd]}">
        <mat-card-header>
          <div mat-card-avatar class="example-header-image"></div>
          <mat-card-title>
            {{ app?.cl_cd }}
          <span *ngIf="appchanges[app?.cl_cd]" matBadge="" matBadgeColor="warn" matBadgePosition="above after" #tooltip="matTooltip"    matTooltipPosition="below"
                  matTooltip="Changes have been made to the App. Please restart the App to apply the new changes" 
                  matTooltipHideDelay="100000"
                  aria-label="Button that displays a tooltip that hides when scrolled out of the container"
                  class="change-badge"><mat-icon class="menu-icon" (click)="autoRenew(app)">autorenew</mat-icon></span>
          </mat-card-title>
          <mat-card-subtitle>{{ app['cl_val'] }}</mat-card-subtitle>
        </mat-card-header>
        <div style="text-align: center; background: url('../../assets/default_app.jpg') center/cover; width: 200px; height: 200px; text-align: center; margin: 0 auto;">
          <img src="../../assets/default_app.jpg" alt="Photo of a Shiba Inu" style="opacity: 0; width: 100%; height: 100%; text-align: center;" (click)="view(app)">
        </div>
        <mat-card-content>
          <p class="fixed-size-para">
            {{ app['cl_desc'] }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button class="btn card-header-1" (click)="visit(app)">
            <mat-icon class="menu-icon">open_in_new</mat-icon>
          </button>
          <button class="btn card-header-1" [matMenuTriggerFor]="menu"  id="menubtn"><i class="fa fa-ellipsis-h"></i></button>
          <mat-menu #menu="matMenu" xPosition="after" yPosition="below">
            <button mat-menu-item class="menu-item" (click)="initializeApp(app)" *ngIf="!appsstatus[app?.cl_cd]">
              <mat-icon class="menu-icon">play_circle_outline</mat-icon>
              <span>Initialize App</span>
            </button>
            <button mat-menu-item class="menu-item" (click)="stopapp(app)" *ngIf="appsstatus[app?.cl_cd]">
              <mat-icon class="menu-icon">stop</mat-icon>
              <span>Stop App</span>
            </button>
            <button mat-menu-item class="menu-item" (click)="modify(app)">
              <mat-icon class="menu-icon">build</mat-icon>
              <span>Modify</span>
            </button>
          </mat-menu>
        </mat-card-actions>
      </mat-card>
      
      
      


</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
